import {Manhole} from "../../../../../types";
import {LidGeometry} from "./lidGeometry";
import {getClosuresIntersectionPositions, getClosureSizes} from "../../../../domain/manhole";

export interface ManholeGeometry {
    tx: number;
    ty: number;
    rot: number;
    left: number;
    right: number;
    top: number;
    bottom: number;
    width: number;
    height: number;
    clearTop: number;
    clearBottom: number;
    rabbetWidth: number;
    closureWidth: number;
    closureHeight: number;
    verticalClosureIntersectionsX: number[];
    horizontalClosureIntersectionsY: number[];
}

export function createManholeGeometry(
    manhole: Manhole,
    scale: number,
    lidGeometry: LidGeometry
): ManholeGeometry {
    const physicalClosureSizes = getClosureSizes(manhole.type);
    const physicalRabbetWidth = () => physicalClosureSizes?.rabbetWidth ?? 0;
    const rabbetWidth = () => physicalRabbetWidth() * scale;

    const realClosureWidth = () => physicalClosureSizes?.width ?? 0;
    const closureWidth = () => realClosureWidth() * scale;
    const realClosureHeight = () => physicalClosureSizes ? physicalClosureSizes.height + 2 * physicalRabbetWidth() : 0;
    const closureHeight = () => realClosureHeight() * scale;

    const isVertical = manhole.orientation === 'vertical';

    const physicalClearHeight = () => (isVertical ? manhole.height : manhole.width);
    const physicalClearWidth = () => (isVertical ? manhole.width : manhole.height);

    const physicalHeight = () => physicalClearHeight() + 2 * physicalRabbetWidth();
    const physicalWidth = () => physicalClearWidth();

    const height = () => physicalHeight() * scale;
    const width = () => physicalWidth() * scale;

    const tx = () => lidGeometry.clearLeft + manhole.x * scale + (isVertical ? 0 : clearHeight() + rabbetWidth());
    const ty = () => lidGeometry.clearFront - (manhole.y + manhole.height) * scale - (isVertical ? rabbetWidth() : 0);
    const rot = () => (isVertical ? 0 : 90);

    const left = () => 0;
    const right = () => left() + width();
    const top = () => 0;
    const bottom = () => top() + height();

    const clearTop = () => rabbetWidth();
    const clearBottom = () => bottom() - rabbetWidth();
    const clearHeight = () => physicalClearHeight() * scale;

    const verticalClosureIntersectionsX = () => {
        return physicalClosureSizes
            ? getClosuresIntersectionPositions(width(), physicalClosureSizes.width * scale)
            : [];
    }
    const horizontalClosureIntersectionsY = () => {
        const intersectionPositions = getClosuresIntersectionPositions(physicalHeight(), realClosureHeight())

        return intersectionPositions.map(p => p * scale);
    }
    return {
        tx: tx(), ty: ty(), rot: rot(),
        left: left(), right: right(), top: top(), bottom: bottom(), width: width(), height: height(),
        clearTop: clearTop(), clearBottom: clearBottom(),
        rabbetWidth: rabbetWidth(),
        closureWidth: closureWidth(), closureHeight: closureHeight(),
        verticalClosureIntersectionsX: verticalClosureIntersectionsX(),
        horizontalClosureIntersectionsY: horizontalClosureIntersectionsY(),
    };
}